import {
  OwnerPowerOfAttorneyResponse,
  UserContact,
  Owner,
  OwnerBiometricMessageInfo,
} from '@types'
import { Service } from '@tino-frontend/adapters'

export class OwnerService {
  constructor(private readonly httpMerchant: Service) {}

  getCompanyOwners(cnpj: string): Promise<Owner[]> {
    return this.httpMerchant.get(`/v1/poa/${cnpj}/owners`)
  }

  requestOwnerKycForMembershipProve(
    companyName: string,
    companyDocumentNumber: string,
    ownerID: string,
    purchaseOrderID: string,
    supplierID: string
  ): Promise<OwnerPowerOfAttorneyResponse> {
    return this.httpMerchant.post('/v1/poa', {
      company_document_number: companyDocumentNumber,
      company_name: companyName,
      owner_natural_person_id: ownerID,
      purchase_order_id: purchaseOrderID,
      supplier_id: supplierID,
    })
  }

  sendBiometricsLink(data: OwnerBiometricMessageInfo): Promise<void> {
    return this.httpMerchant.post(`v1/poa/message`, data)
  }

  getUserContact(): Promise<UserContact> {
    return this.httpMerchant.get(`v1/me/contact`)
  }

  getWorkflowInfo(workflowID: string): Promise<any> {
    return this.httpMerchant.get(`/v1/poa/checks/${workflowID}/info`)
  }
}
